import { render, staticRenderFns } from "./DiscoveryBrandsIcon.vue?vue&type=template&id=1d2b10b0"
import script from "./DiscoveryBrandsIcon.vue?vue&type=script&lang=js"
export * from "./DiscoveryBrandsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports